<div *ngIf="!isOnErrorPage" class="avano-appheader-container">
  <ng-container *ngTemplateOutlet="logoWithSystemRibbon"></ng-container>
  <ng-content select="avano-appheader-middle-area">
    <!--
    Unofficial way how to place between application name and user/icon area any content
    Why "unofficial"? Because it is not defined in AVANO. So styling here needs to come from the application in total!
    -->
  </ng-content>

  <div class="avano-appheader-userprofile">

    <div *ngIf="userName" #userInfoItem
    >
      <div 
        class="avano-appheader-item" 
        [class.avano-appheader-item-clickable]="!!userPopoverTemplate"
        (click)="userPopoverTemplate ? userPopover.toggle($event) : null"
      >
        <i class="icon-content-user"></i>
        <span class="avano-appheader-user-name">{{userName}}</span>
      </div>
    </div>

    <div class="avano-appheader-item">
      <span *ngIf="userOrg" class="avano-appheader-user-org">{{ userOrg }}</span>
    </div>

    <ng-content select="avano-appheader-icon-area"></ng-content>
  </div>
</div>

<div *ngIf="isOnErrorPage" class="avano-appheader-container avano-appheader-error">
  <ng-container *ngTemplateOutlet="logoWithSystemRibbon"></ng-container>
</div>

<avano-popover #userPopover>
  <ng-container [ngTemplateOutlet]="userPopoverTemplate"></ng-container>
</avano-popover>

<!-- Templates -->
<ng-template #logoWithSystemRibbon>
  <div class="avano-appheader-appinformation">
    <div class="avano-appheader-logo-with-appname"></div>
  </div>
  <div *ngIf="systemRibbonText" class="topbar-system-ribbon">
    <span>{{ systemRibbonText }}</span>
  </div>
</ng-template>

<ng-template #userPopoverUserInfo [typedTemplate]="templateTypes?.userPopoverUserInfoData" let-userInfo>
  <div class="user-profile-short">
    <i class="icon-content-user-profile"></i>
    <div>
      <div class="user-profile-short-fullname">{{userInfo.fullName}}</div>
      <div class="user-profile-short-email">{{userInfo.email}}</div>
      <div class="user-profile-short-role">{{userInfo.role}}</div>
    </div>
  </div>
</ng-template>
